<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab title="Summary" active>
                <CreateServiceRequest :item="this.order" />
            </b-tab>
            <b-tab title="Messages">
                <b-card-body><ServiceNotes :order="order" /></b-card-body>
            </b-tab>
            <b-tab title="Attachments">
                <b-card-body>
                    <ServiceAttachments :order="order" />
                </b-card-body>
            </b-tab>
            <b-tab title="Details">
                <service-request-items :order="order" />
            </b-tab>
            <b-tab title="Ratings">
                <b-card-body>
                    <b-form-group
                        id="input-group-reference-no"
                        label="Reference No"
                        label-for="input-reference-no"
                        label-class="font-weight-bold pt-0"
                        label-cols="2"
                    >
                        <b-form-input
                            id="input-reference-no"
                            v-model="serviceRequest.reference_no"
                            type="text"
                            required
                            :disabled="!editMode"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-group-feedback"
                        label="Feedback"
                        label-for="input-feedback"
                        label-class="font-weight-bold pt-0"
                        label-cols="2"
                    >
                        <b-form-rating
                            body-class="p-0 text-left"
                            id="input-feedback"
                            v-model="serviceRequest.feedback"
                            :disabled="!editMode"
                        >
                        </b-form-rating>
                    </b-form-group>
                    <b-form-group
                        id="input-group-feedback-comments"
                        label="Feedback Comments"
                        label-for="input-feedback-comments"
                        label-class="font-weight-bold pt-0"
                        label-cols="2"
                    >
                        <b-form-textarea
                            id="input-description"
                            v-model="serviceRequest.feedback_comments"
                            placeholder="Enter your feedback for this activity..."
                            rows="3"
                            max-rows="4"
                            :disabled="!editMode"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-button-group
                        v-if="!editMode && !serviceRequest.feedback_comments"
                    >
                        <b-button
                            size="sm"
                            class="my-2"
                            @click="editMode = !editMode"
                            variant="primary"
                        >
                            Add Rating
                        </b-button>
                    </b-button-group>

                    <b-button-group size="sm" v-else-if="editMode">
                        <b-button
                            size="sm"
                            class="my-2"
                            @click="onSubmit"
                            variant="primary"
                        >
                            Save Changes
                        </b-button>
                        <b-button
                            size="sm"
                            class="my-2"
                            @click="editMode = !editMode"
                            variant="secondary"
                        >
                            Cancel
                        </b-button>
                    </b-button-group>
                </b-card-body>
            </b-tab>
            <b-tab title="Documents">
                <b-container fluid class="p-4 bg-light">
                    <b-button class="my-2" @click="downloadPdf">
                        Download Documents
                        <b-spinner
                            class="ml-2"
                            small
                            v-if="loading"
                        ></b-spinner>
                        <b-icon
                            v-else
                            class="ml-2"
                            icon="cloud-download"
                            aria-hidden="true"
                        ></b-icon>
                    </b-button>
                </b-container>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

import ServiceAttachments from './ServiceAttachments'
import ServiceNotes from './ServiceNotes'
import CreateServiceRequest from './CreateServiceRequest.vue'
import ServiceRequestItems from './ServiceRequestItems.vue'

export default {
    name: 'CustomerPortalViewService',
    components: {
        ServiceAttachments,
        ServiceNotes,
        CreateServiceRequest,
        ServiceRequestItems,
    },
    mixins: [popupMixins],
    data() {
        return {
            serviceRequest: {},
            loading: false,
            editMode: false,
            fields: [
                { key: 'id', label: 'Actions' },
                { key: 'reference_no', label: 'Reference Number' },
                {
                    key: 'feedback',
                    label: 'Rating',
                    formatter: (key, value, item) =>
                        item ? item.feedback : 10,
                },
                { key: 'feedback_comments', label: 'Comments' },
                {
                    key: 'driver_id',
                    label: 'Officer',
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                    key: 'completed',
                    label: 'Status',
                    formatter: (value, key, item) => {
                        return item.completed ? 'Completed' : 'In Progress'
                    },
                },
            ],
        }
    },
    filters: {
        filterDate(date) {
            if (!date) return ''
            return date.split(' ')[0]
        },
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
        filterSection(section) {
            if (!section) return ''
            const { name, location } = section || {}
            const { address1, address2, city } = location || {}
            return `${name}<br/>${address1}<br/>${address2}<br/>${city}`
        },
        filterTime(date) {
            if (!date) return ''
            return date.split(' ')[1]
        },
        filterOfficerName(officer) {
            if (!officer) return ''
            return officer.first_name + ' ' + officer.last_name
        },
        filterPrice(items) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            const sum = (items || []).reduce((sum, item) => {
                sum +=
                    parseFloat(item.quantity) *
                    parseFloat(item.price) *
                    (1 + parseFloat(item.tax_rate) / 100)
                return sum
            }, 0)
            if (!sum) return '-'
            return formatter.format(sum)
        },
    },
    computed: {
        orderTypeName() {
            return (
                (this.order &&
                    this.order.type &&
                    (this.order.type.customer_portal_name ||
                        this.order.type.name)) ||
                ''
            )
        },

        driver() {
            const { first_name, last_name } = this.order || {}
            return `${first_name || ''} ${last_name || ''}`
        },

        drivers() {
            return this.$store.state.orders.drivers
        },

        order() {
            console.log('Activity is: ')
            const computedOrder =
                this.$store.state.customerPortal.selectedOrder || {}
            console.log(computedOrder)
            return computedOrder
        },
    },
    watch: {},
    mounted() {
        this.$store.dispatch('customerPortal/fetchOrder', this.$route.params.id)
        this.$store.dispatch('orders/fetchDrivers')

        this.serviceRequest = this.order
    },
    methods: {
        async downloadPdf() {
            try {
                this.loading = true
                const rpt_type = 'statement'
                const queryString = `&id=${this.order.id}`
                const fileName = 'statement.pdf'
                console.log('report params:', {
                    rpt_type,
                    queryString,
                    fileName,
                })
                await this.$store.dispatch('js_report/downloadDocument', {
                    rpt_type,
                    queryString,
                    fileName,
                })
            } catch (error) {
                console.error('downloadPdf:', error)
                this.doToast('Error!', 'Error Downloading Report!', 'danger')
            } finally {
                this.loading = false
            }
        },

        onSubmit() {
            const path = 'customerPortal/updateOrder'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, this.serviceRequest)
                        .then(() => {
                            this.loading = false
                            this.genericToast(
                                'Service Request',
                                'Updated',
                                'success',
                                `Service request rating has been successfully updated`
                            )
                            // const message = model.id ? 'Updated' : 'Created'
                        })
                        .catch(error => {
                            console.error('Customer rating submit error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
    },
}
</script>
<style></style>
